import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Status from '../Status';
import StepByStep from '../../StepByStep';
import {
  ADD_ADDRESS_WIZARD,
  STATUS_NEW_ADDRESS_ADDED,
} from '../../../constants/sessionStorage';
import { storeInSessionStorage } from '../../../util/helpers/sessionStorageHelper';
import BasicModal from '../../BasicModal/BasicModal';
import AddDeliveryAddress from './AddDeliveryAddress';

const steps = [AddDeliveryAddress, Status];

const AddDeliveryAddressModal = ({
  isOpen,
  onClose,
  page,
  title,
  isAddingCCFlow,
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState('');

  const handleNext = () => {
    if (!error) storeInSessionStorage(STATUS_NEW_ADDRESS_ADDED, true);
    onClose();
  };

  return (
    <BasicModal
      title={title}
      size="sm"
      isOpen={isOpen}
      close={onClose}
      closeIconVisible
    >
      {page === 'address' ? (
        <StepByStep saveStepDisabled sessionScopeStep={ADD_ADDRESS_WIZARD}>
          {({ goStepForward, goStepBack }) =>
            steps.map((step) =>
              React.createElement(step, {
                handleBack: goStepBack,
                handleNext: goStepForward,
                handleClose: onClose,
                onButtonClick: onClose,
                hasError: !!error,
                text:
                  error || t('account.addresses.addAddressSuccessfulMessage'),
                backButtonText: t('common.ok'),
                setError,
              }),
            )
          }
        </StepByStep>
      ) : (
        <AddDeliveryAddress
          onButtonClick={onClose}
          handleNext={handleNext}
          setError={setError}
          isAddingCCFlow={isAddingCCFlow}
        />
      )}
    </BasicModal>
  );
};

AddDeliveryAddressModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  page: PropTypes.string,
  title: PropTypes.string,
  isAddingCCFlow: PropTypes.bool,
};

export default AddDeliveryAddressModal;
